export default "__VITE_ASSET__8b1a9140__"